/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mCountUp.vue?vue&type=template&id=52d28f76&scoped=true"
import script from "./mCountUp.vue?vue&type=script&lang=js"
export * from "./mCountUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d28f76",
  null
  
)

export default component.exports